import React, { Component } from 'react';
// Components
import TextField from './TextField';

// Images import
import PlusIcon from "../assets/images/plus_icon.svg";
import Loader from './loader';

//Service import
import service from '../services'


//Validation import 
import SimpleReactValidator from 'simple-react-validator';

class HomePageTile extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            post:'Post',
            outbound:'Outbound',
            postFlag:true,
            tileOutbound:false,
            Tile:this.props.Tile
        }
        this.apiserve = new service(); 
        this.validatePage = this.validatePage.bind(this);  
        this.validator = new SimpleReactValidator({ autoForceUpdate: this,
            validators: {
              urlValidation: {  // name the rule
                message: 'Please use a valid name of the :attribute',
                rule: (val, params, validator) => {
                  return validator.helpers.testRegex(val,/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=])/) && params.indexOf(val) === -1
                },
                required: true  // optional
              }
          }
        });
        // this.props.urlValidation.showMessages()
    }

    handleText = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    validatePage = (isValid) => {
        const isValid1 = this.validator.allValid()

        isValid(isValid1)
    }

    handleImageChange = (e) => {
        e.stopPropagation()
        e.preventDefault();
        let data ={}
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        
        reader.onloadend = (event) => {
          
            data ={
                _id:this.props.data._id,
                file: file,
            }
            this.upload.value = "";

            this.props.imageChange(data,event.target.result)
        }
        
        
    }

    handleChange = (e) => {
        
        const { name, value } = e.target;
        var data = {}

        if(name === 'tileOutbound')
        {
            data = {
                _id:this.props.data._id,
                name:name,
                value:JSON.parse(value)
            }
        }
        else
        {
            data = {
                _id:this.props.data._id,
                name:name,
                value:value
            }
        } 

        this.props.onChange(data)
    }

    changeType = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        },()=>{
            if(this.state.post){
                this.setState({
                    postFlag:!this.state.postFlag
                })
            }else{
                this.setState({
                    tileOutbound:!this.state.tileOutbound
                })
            }
        })
        
    }

    render() {
        return (
            <div className="home_page_title_wpr">
                <div className="title_header">
                    <p>{this.state.Tile}</p>

                    <div class="tile_dropdown">
                        <select 
                            value={this.state.selectType}
                            name='tileOutbound' 
                            onChange={this.handleChange.bind(this)}>  
                            <option value={false} selected={this.props.data.tileOutbound ? false : true}>Post</option>
                            <option value={true} selected={this.props.data.tileOutbound ? true : false}>Outbound</option>
                        </select>
                    </div>
                </div>
                <div className="title_content">
                    <div className="title_content_img">
                        <div className="title_content_img_box loader-main">
                            <input 
                                type="file"  
                                type="file"
                                ref={(ref) => (this.upload = ref)}
                                onChange={this.handleImageChange}
                                accept=".png, .jpg, .jpeg"
                            />
                            {
                                this.state.imagePreloader ?
                                    <Loader/>
                                    :
                                    <img className="title_content_image" src={
                                        this.props.data.tileImage  ?
                                            this.apiserve.imageUrl + this.props.data.tileImage 
                                        : ''
                                    } />
                            }
                            <span className="add_img">
                                <img src={PlusIcon} className="img_add_icon" onClick={() => { this.upload.click() }}/>
                            </span>
                            <span className="error_msg">{this.props.imageErr}</span>
                        </div>
                        <span className="error_note">Max size 2MB</span>

                        <div className="form_group form_group_input"> 
                            <TextField  label="Image description" name="tileImageDescription" value={this.props.data.tileImageDescription} type="text" onChange={this.handleChange} />
                            <span className="error_msg">Please enter tile title.</span>                                                
                        </div>
                    </div>
                    <div className="title_content_form">
                        
                        <div className="form_group form_group_input"> 
                            <TextField name="tileTitle" name='tileTitle' value={this.props.data.tileTitle} label="Tile Title" type="text" onChange={this.handleChange}/>
                            <span className="error_msg">Please enter tile title.</span>                                                
                        </div>

                        {this.props.data.tileOutbound === false &&
                        <>
                            <div className="form_group form_group_textarea"> 
                                <div className="form_group_inner"> 
                                    <label>Tile Subtext 1</label> 
                                    <textarea rows="11" name="tileSubTitle1" value={this.props.data.tileSubTitle1} onChange={this.handleChange}></textarea>                                                  
                                </div>
                                <span className="error_msg">Please enter tile subtitle.</span>                                                
                            </div>

                            <div className="form_group form_group_textarea"> 
                                <div className="form_group_inner"> 
                                    <label>Tile Subtext 2</label> 
                                    <textarea rows="19" name="tileSubTitle2" value={this.props.data.tileSubTitle2} onChange={this.handleChange}></textarea>                                                  
                                </div>
                                <span className="error_msg">Please enter tile subtitle.</span>                                                
                            </div>
                        </>
                        }
                        
                        <div className="form_group form_group_input form_group_input_cta"> 
                            <TextField name="tileCTA" label="Tile CTA" value={this.props.data.tileCTA} type="text" onChange={this.handleChange}/>
                            <span className="error_msg">Please enter tile cta.</span>                                                
                        </div>
                        {this.props.data.tileOutbound === true &&
                        <>
                        <div className="form_group form_group_input"> 
                            <TextField name="tileUrl" value={this.props.data.tileUrl} label="Tile URL" type="text" onChange={this.handleChange} placeholder="https://gotourl.com" />
                            <span style={{ color: 'red' }}>{this.validator.message('Tile url', this.props.data.tileUrl , 'required')}</span>
                        </div>
                        </>
                        }
                    </div>
                </div>
            </div>
        )
    }
}
export default HomePageTile;